import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDashboard(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/finance/dashboard', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchWeeks(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/finance/weeks', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchWeek(ctx, weekId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/finance/weeks/${weekId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPayouts() {
      return new Promise((resolve, reject) => {
        axios
          .get('/finance/payouts')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPacksRoi(ctx, params) {
      const normalized = { ...params }
      if (typeof normalized.include_archived === 'boolean') {
        normalized.include_archived = normalized.include_archived ? 1 : 0
      }
      return new Promise((resolve, reject) => {
        axios
          .get('/finance/packs/roi', { params: normalized })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
